import step1Chrome from '../../assets/img/step1Chrome.png'
import step1Edge from '../../assets/img/step1Edge.png'
import step1Firefox from '../../assets/img/step1Firefox.png'
import step1Opera from '../../assets/img/step1Opera.png'
import step2 from '../../assets/img/step2.png'
import step3 from '../../assets/img/step3.png'

export const downloadButtonText = (
  client: string = "",
  platform: string
): string => `Velox Viewer ${client ? client : "GA"} (${platform})`;

export const addPageScroll = (): void => {
  const body = document.querySelector("body");
  if (body) {
    body.style.overflowY = "hidden";
  }
};

export const removePageScroll = (): void => {
  const body = document.querySelector("body");
  if (body) {
    body.style.overflowY = "scroll";
  }
};

export const compareVersions = (
  currentVersion: string,
  version: string
): boolean => {
  if (currentVersion) {
    const currentVersionArr = currentVersion.split('.')
    const versionArr = version.split('.')
    let compReslut = false;

    currentVersionArr.forEach((elem, index) => {
      if (Number(elem) > Number(versionArr[index]))
        compReslut = true;
    })
    return compReslut;
  }
  else return false;
};


export const InstractionSteps = {
  step2: {
    label: "Step 2",
    title: "Run the installer",
    instruction: "Run the installer and follow the next steps.",
    imgSrc: step2,
  },
  step3: {
    label: "Step 3",
    title: "Successful installation",
    instruction: "Follow all the steps and the Velox Viewer will be installed.",
    imgSrc: step3,
  }
}

export const getFirstStepInstruction = (browserName: string, fn: string | null = "Radiology_Installer",) => {
  switch (browserName) {
    case "Chrome":
      return {
        label: "Step 1",
        title: "Open the installer",
        instruction: `Find the ${fn}.exe file in the list of downloaded files located in the lower left corner of this window and open it.`,
        imgSrc: step1Chrome,
      }
    case "Firefox":
      return {
        label: "Step 1",
        title: "Open the installer",
        instruction: `Find the ${fn}.exe file in the list of downloaded files located in the upper right corner of this window and open it.`,
        imgSrc: step1Firefox,
      }
    case "Opera":
      return {
        label: "Step 1",
        title: "Open the installer",
        instruction: `Find the ${fn}.exe file in the list of downloaded files located in the upper right corner of this window and open it.`,
        imgSrc: step1Opera,
      }
    case "Edge":
      return {
        label: "Step 1",
        title: "Open the installer",
        instruction: `Find the ${fn}.exe file in the list of downloaded files located in the upper right corner of this window and open it.`,
        imgSrc: step1Edge,
      }
    default:
      return {
        label: "Step 1",
        title: "Open the installer",
        instruction: `Find the ${fn}.exe file in the list of downloaded files located in the lower left corner of this window and open it.`,
        imgSrc: step1Chrome,
      };
  }
}

